import { useAddPhmsaReportExportJobMutation } from 'app/services/api/phmsa/phmsareport'
import { useExportJobContext } from 'common/contexts/useExportJobContext'

import { IExportPHMSAButtonProps } from './types'

const ExportPHMSAButton = ({ exportParams }: IExportPHMSAButtonProps) => {
  const [addPhmsaExportJob] = useAddPhmsaReportExportJobMutation()
  const { exportJob, isJobPending, createDataExportJob } = useExportJobContext()

  return (
    <button
      className={[
        'mt-2 ml-2 w-32 h-10 rounded',
        'bg-lighthouseBlue',
        'font-semibold uppercase text-white',
        'disabled:opacity-50'
      ].join(' ')}
      disabled={exportJob.isFetching || isJobPending}
      onClick={() =>
        createDataExportJob(addPhmsaExportJob, exportParams, 'PHMSA_Export')
      }
    >
      {exportJob.isFetching || isJobPending ? 'Exporting...' : 'Export'}
    </button>
  )
}

export default ExportPHMSAButton
